/*
 * Copyright (c) 2019-2021 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { FooterListItem } from './FooterListItem/FooterListItem';
import { Flex } from '@getgo/chameleon-chakra-ui';
import { Divider } from '../Divider/Divider';

const about = 'https://goto.com/company/about-us';
const tos = 'https://goto.com/company/legal/terms-and-conditions';
const privacy = 'https://goto.com/company/legal/privacy';
const explore = 'https://goto.com';

const messages = defineMessages({
  aboutUs: {
    id: 'footer.aboutUs',
  },
  termsOfService: {
    id: 'footer.termsOfService',
  },
  privacyPolicy: {
    id: 'footer.privacyPolicy',
  },
  exploreGoTo: {
    id: 'footer.exploreGoTo',
  },
});

export const Footer: React.FC = () => {
  const { formatMessage: f } = useIntl();

  return (
    <Flex id='footer' px='1rem' pb='0.75rem' role='presentation'>
      <FooterListItem link={about} linkText={f(messages.aboutUs)} />
      <Divider />
      <FooterListItem
        link={tos}
        linkText={f(messages.termsOfService)}
        breakWords
      />
      <Divider />
      <FooterListItem
        link={privacy}
        linkText={f(messages.privacyPolicy)}
        breakWords
      />
      <Divider />
      <FooterListItem link={explore} linkText={f(messages.exploreGoTo)} />
    </Flex>
  );
};
